import { useContext } from "react";
import NotificationSvg from "../../assets/taiga-uikit/icons/notification.svg?react";
import SendSvg from "../../assets/taiga-uikit/icons/send-2.svg?react";
import { PublicContext } from "../../Contexts/PublicContext";
import { StoreExecutorContext } from "../../Contexts/Store/StoreExecutor";
import { _size, _style, _typeLogo } from "../../core/core";
import { useNotificationCount } from "../../hooks/useNotificationCount";
import { BreadCrumbs } from "../BreadCrumbs/BreadCrumbs";
import { Button } from "../button/button";
import { Link } from "../link/link";
import { Loader } from "../Loader/Loader";
import { Logo } from "../Logo/Logo";
import { Stepper } from "../Stepper/Stepper";
import "./header.css";

interface HeaderProps {
  isPublic?: boolean;
  breadLinks?: { name: string; url: string }[];
  isMainPage?: boolean;
  [key: string]: any;
}

const Header: React.FC<HeaderProps> = ({
  isPublic = false,
  breadLinks = [],
  isMainPage = false,
  ...props
}) => {
  const { isClient, setIsClient } = useContext(PublicContext);
  const storeExecutorContext = useContext(StoreExecutorContext);
  const isLoading = storeExecutorContext?.isLoading || false;
  const isVersionAndAndroid = (): boolean => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("version");
    if (value) return false;

    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("android");
  };

  const getLogic = () => {
    if (!isPublic) {
      return breadLinks ? <BreadCrumbs links={breadLinks} /> : null;
    }
    return (
      <div className="hedaer-left-group">
        {isClient ? (
          <>
            <Link style={_style.primary_clear} link="/uslugi/">
              УСЛУГИ
            </Link>
            <Link style={_style.primary_clear} link="/about/?client=true">
              О ПЛАТФОРМЕ
            </Link>
            <Link style={_style.primary_clear} link="/blog/?client=true">
              БЛОГ
            </Link>
          </>
        ) : (
          <>
            <Link
              style={_style.primary_clear}
              link="/ispolniteli/zadaniya/?client=false"
            >
              ЗАДАНИЯ
            </Link>
            <Link style={_style.primary_clear} link="/about/?client=false">
              О VIWORK
            </Link>
            <Link style={_style.primary_clear} link="/blog/?client=false">
              БЛОГ
            </Link>
            <Link
              style={_style.primary_clear}
              link="/ispolniteli/top/?client=false"
            >
              РЕЙТИНГ
            </Link>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="header-block" {...props}>
      <div className="header">
        <div className="hedaer-left">
          <Logo
            link="/"
            type={isClient ? _typeLogo.default : _typeLogo.secondary}
          />
          {getLogic()}
        </div>
        {!isPublic && !isClient && (
          <div className="header-right">
            {isVersionAndAndroid() && (
              <Link
                style={_style.outline}
                size={_size.M}
                blank
                link="https://viw.im/static/apps/work.apk"
              >
                🔥ANDROID
              </Link>
            )}
            <Loader isLoading={isLoading}></Loader>
            <Link
              blank
              link="https://t.me/workvvlabspace/1/37204"
              style={_style.clear2}
              size={_size.M}
            >
              <SendSvg />
            </Link>
            {<NotificationPreview></NotificationPreview>}
          </div>
        )}
        {isPublic && (
          <div className="header-right">
            {isMainPage ? (
              <Link
                link="ispolniteli/?client=false"
                style={_style.primary_clear}
                size={_size.M}
              >
                Я исполнитель
              </Link>
            ) : (
              <Button
                onClick={() => setIsClient(!isClient)}
                style={_style.primary_clear}
              >
                Я {isClient ? "исполнитель" : "клиент"}
              </Button>
            )}
            <Link
              blank
              link={`/authorize/auth/?client=${isClient}`}
              style={_style.primary}
              size={_size.M}
            >
              Войти
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
const NotificationPreview = () => {
  const { note } = useNotificationCount();
  return (
    <Link link="/notifications/" style={_style.clear2} size={_size.M}>
      <NotificationSvg />
      {note.count !== 0 && (
        <Stepper active count={note.count} top="-12px" left="-9px" />
      )}
    </Link>
  );
};

export default Header;
